import { ArrowLeft, ArrowRight } from "lucide-react";
import { useI18n } from "@/i18n";

export function QuizNav({ isContact, isLast, hasAnswer, onBack, onNext }) {
  const { t } = useI18n();
  return (
    <div className="mt-10 flex items-center justify-between">
      <button
        data-testid="quiz-back-button"
        onClick={onBack}
        className="inline-flex items-center gap-2 text-[#4b5b7c] font-semibold hover:text-[#1a2d56] transition-colors"
      >
        <ArrowLeft size={18} /> {t("back")}
      </button>
      {!isContact && !isLast && (
        <button
          data-testid="quiz-next-button"
          onClick={onNext}
          disabled={!hasAnswer}
          className="inline-flex items-center gap-2 font-semibold text-[#1a2d56] disabled:opacity-40"
        >
          {t("next")} <ArrowRight size={18} />
        </button>
      )}
    </div>
  );
}
